import FIN_HERO_IMG from "../../assets/fin-hero-img.png";

import FIN_SEC2_IMG1 from "../../assets/fin-sec2-1.png"
import FIN_SEC2_IMG2 from "../../assets/fin-sec2-2.png"
import FIN_SEC2_IMG3 from "../../assets/fin-sec2-3.png"
import FIN_SEC2_IMG4 from "../../assets/fin-sec2-4.png"
import FIN_SEC2_IMG5 from "../../assets/fin-sec2-5.png"

import FIN_SEC3_DESKTOPIMG from "../../assets/fin-sec3-desktopImg.png"
import FIN_SEC3_MOBILEIMG from "../../assets/fin-sec3-mobileImg.png"

import FIN_ASSESSMENT_1 from "../../assets/fin_assessment_1.png"
import FIN_ASSESSMENT_2 from "../../assets/fin_assessment_2.png"
import FIN_ASSESSMENT_3 from "../../assets/fin_assessment_3.png"
import FIN_ASSESSMENT_4 from "../../assets/fin_assessment_4.png"
import FIN_ASSESSMENT_5 from "../../assets/fin_assessment_5.png"
import FIN_ASSESSMENT_1_MOBILE from "../../assets/fin_assessment_1-M.png"
import FIN_ASSESSMENT_2_MOBILE from "../../assets/fin_assessment_2-M.png"
import FIN_ASSESSMENT_3_MOBILE from "../../assets/fin_assessment_3-M.png"
import FIN_ASSESSMENT_4_MOBILE from "../../assets/fin_assessment_4-M.png"
import FIN_ASSESSMENT_5_MOBILE from "../../assets/fin_assessment_5-M.png"

import FIN_SEC5_IMG1 from "../../assets/fin-sec5-1.png"
import FIN_SEC5_IMG2 from "../../assets/fin-sec5-2.png"

import FIN_SEC6_IMG1 from "../../assets/fin-sec6-1.png"
import FIN_SEC6_IMG2 from "../../assets/fin-sec6-2.png"
import FIN_SEC6_IMG3 from "../../assets/fin-sec6-3.png"
import FIN_SEC6_IMG4 from "../../assets/fin-sec6-4.png"

import FIN_SEC8_MOBILEIMG from "../../assets/fin-sec8-mobileImg.png"

import LEFT_DIRECTION_BTN from "../../assets/leftDirBtn.png"
import RIGHT_DIRECTION_BTN from "../../assets/rightDirBtn.png"


export const IMAGES = {
    FIN_HERO_IMG,
    FIN_SEC2_IMG1,
    FIN_SEC2_IMG2,
    FIN_SEC2_IMG3,
    FIN_SEC2_IMG4,
    FIN_SEC2_IMG5,
    FIN_SEC3_DESKTOPIMG,
    FIN_SEC3_MOBILEIMG,
    FIN_ASSESSMENT_1,
    FIN_ASSESSMENT_2,
    FIN_ASSESSMENT_3,
    FIN_ASSESSMENT_4,
    FIN_ASSESSMENT_5,
    FIN_ASSESSMENT_1_MOBILE,
    FIN_ASSESSMENT_2_MOBILE,
    FIN_ASSESSMENT_3_MOBILE,
    FIN_ASSESSMENT_4_MOBILE,
    FIN_ASSESSMENT_5_MOBILE,
    FIN_SEC5_IMG1,
    FIN_SEC5_IMG2,
    FIN_SEC6_IMG1,
    FIN_SEC6_IMG2,
    FIN_SEC6_IMG3,
    FIN_SEC6_IMG4,
    FIN_SEC8_MOBILEIMG,
    LEFT_DIRECTION_BTN,
    RIGHT_DIRECTION_BTN
}